import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';

/**
 * Live-session banner at the top of the page.
 * Custom mode: auto-hides after 10 s × index with a progress bar (unchanged).
 * Unified Code mode: the DGA "Notification" (criterion 18, high-priority permanent message at the top of
 * the page) — it stays until the user dismisses it and can carry an optional action link.
 */
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, OnDestroy {
  @Input() index: number;
  @Input() title: string;
  /** Optional action (router link + label) shown in Unified Code mode. */
  @Input() actionLink: string | any[] | null = null;
  @Input() actionLabel: string | null = null;
  timer: number = 10000;
  readonly isUnifiedCode: boolean;
  private interval: ReturnType<typeof setInterval>;

  constructor(identityService: IdentityService) {
    this.isUnifiedCode = identityService.isUnifiedCode();
  }

  ngOnInit(): void {
    if (this.isUnifiedCode) return;

    this.timer = this.timer * this.index;
    this.interval = setInterval(() => {
      this.timer -= 50;

      if(this.timer < 0) {
        this.timer = 0;
        clearInterval(this.interval);
      }
    }, 50);
  }

  dismiss(): void {
    this.timer = 0;
    clearInterval(this.interval);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
